require("./bootstrap");
// Import modules...
import { createApp, h } from "vue";
import { createInertiaApp } from "@inertiajs/inertia-vue3";
import { InertiaProgress } from "@inertiajs/progress";

const el = document.getElementById("app");

createInertiaApp({
    resolve: (name) => require(`./Pages/${name}`).default,
    setup({ el, app, props, plugin }) {
        createApp({
            mounted() {
                window.addEventListener("popstate", () => {
                    this.$page.props.popstate = true;
                });
            },
            render: () => h(app, props),
        })
            .mixin({
                methods: {
                    route,
                    settings: () => {
                        return settings;
                    },
                    asset: (path) => {
                        return `${route("admin.dashboard")}/storage/${path}`;
                    },
                },
            })
            .use(plugin)
            .mount(el);
    },
});

InertiaProgress.init({ color: "#4B5563" });
